import { Card, CardBody, CardHeader, TabPane } from "reactstrap";
import ViewBookmark from "../ViewBookmarks";
import { useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { MyBookmark } from "../../../../Constants/Constants";
import { H4 } from "../../../../AbstractElements";
import DataLoop from "./DataLoopTab/DataLoop";

const MyBookmarkTab = () => {
  const { gridView } = useAppSelector((state) => state.bookmarkTab);
  return (
    <TabPane tabId="4">
      <Card className="mb-0">
        <CardHeader className="d-flex">
          <H4 className="mb-0">{MyBookmark}</H4>
          <ViewBookmark />
        </CardHeader>
        <CardBody>
          <div className={`details-bookmark text-center ${gridView ? "" : "list-bookmark"}`}>
            <DataLoop />
          </div>
        </CardBody>
      </Card>
    </TabPane>
  );
};

export default MyBookmarkTab;
